import { observable } from "mobx";

export default class FaultyCombinationsFilter {
  @observable areaId?: string;
}
